// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"357":"c8fe78fd","383":"e3e25302","761":"c1b9bb95","929":"af8f9ed8"}[chunkId] + ".chunk.js";
};